Apt.fn.make('index', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 * @param {Function} [fn]
	 * @returns {Object}
	 */
	init(options, fn) {
		const scope = this;
		const priv = scope.$private;
		const conf = Object.assign({
			event: 'push',
			filters: {},
			history: false,
			init: true,
			model: {},
			paginate: false,
			params: {},
			sorting: false,
			target: '$results',
			title: document.title.split('-')[0]
		}, options);

		scope.uid = LS.util.uid();

		if (! conf.app) {
			conf.app = scope.uid;
		}

		if (! conf.static) {
			Object.assign(conf.filters, LS.filters.get());
		}

		conf.$target = $(conf.target);

		if (conf.paginate) {
			conf.params.paginate = true;
		}

		conf.resource = '/' + conf.resource;

		conf.path = conf.path ?
			conf.path : conf.resource;

		scope.conf = conf;

		priv.sorted = '';

		priv.initSorting(conf);

		priv.load(data => {
			priv.initControls(conf);

			if (fn) {
				fn(data);
			}
		});

		return scope;
	},

	/**
	 * Request filtered data from index endpoint
	 *
	 * @param {Object} options
	 * @param {Object} [filters]
	 */
	update(options, filters) {
		const scope = this;
		const priv = scope.$private;

		if (filters) {
			scope.conf.filters = filters;
		} else {
			filters = {};
		}

		options = Object.assign({}, scope.conf, options);

		priv.go({
			action: options.action || 'replace',
			event: options.event || false,
			path: options.resource,
			scrollTop: options.scrollTop
		}, priv.prep(filters));
	},

	/**
	 * Request filtered data from index endpoint
	 *
	 * @param {Object} [filters]
	 * @param {String} [path]
	 * @param {Object} [options]
	 */
	filter(filters, path, options) {
		const scope = this;
		const priv = scope.$private;
		const conf = scope.conf;

		let title;

		filters = Object.assign(conf.filters, filters);

		if (conf.build) {
			conf.build(filters);
		}

		if (! path) {
			let criteria = filters;

			if (filters.sort === priv.sorted) {
				criteria = $.copy(filters);

				delete criteria.sort;
			}

			path = LS.filters.build(conf.path, criteria);
		}

		title = priv.getPageTitle();

		if (conf.reload) {
			priv.xhr = $.history.go({
				path: path,
				action: false,
				scrollEarly: true,
				scrollTop: false,
				title: title
			});

			return;
		}

		priv.go(Object.assign({
			path: conf.resource,
			route: conf.event ?
				path : null,
			title: title
		}, options), priv.prep(filters, ! conf.static));
	},

	/**
	 * Make initial data request
	 *
	 * @param {Object} options
	 * @param {Function} [fn]
	 */
	request(options, fn) {
		const scope = this;
		const priv = scope.$private;
		const conf = scope.conf;
		const filters = options.filters || {};

		if (conf) {
			$.exec(conf.translate, {
				args: [filters, options]
			});
		}

		priv.xhr = LS.api.get(options.resource, {
			auth: conf && conf.auth,
			data: filters ?
				LS.util.sanitize(filters) : null,
			send: conf && conf.send,
			flash: ! conf || conf.flash !== false,
			success: obj => {
				priv.fetched = true;

				priv.transform(options, obj);

				if (fn) {
					fn(obj);
				}
			},
			complete: () => {
				priv.xhr = null;

				if (conf) {
					conf.$target.removeClass('-is-loading');
				}
			}
		});
	},

	/**
	 * Abort existing index request
	 */
	abort() {
		const priv = this.$private;

		if (priv.xhr && priv.xhr.abort) {
			priv.xhr.abort();

			priv.xhr = null
		}
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		const scope = this;

		scope.abort();

		$.events.reset(scope.uid);

		$.exec(scope.conf.unload, {
			args: true
		});

		LS.util.destroy(scope, 'app');

		$.exec(scope.conf.destroy);
	}
}, {
	/**
	 * Prepare filters for processing
	 *
	 * @param {Object} filters
	 * @param {Boolean} [dynamic=false]
	 * @returns {Object} data
	 */
	prep(filters, dynamic) {
		const scope = this;
		const conf = scope.$public.conf || {};

		if (dynamic) {
			filters = Object.assign(LS.filters.get(), filters);
		}

		if (! filters.sort && scope.sorted) {
			filters.sort = scope.sorted;
		}

		return Object.assign({}, filters, conf.params);
	},

	/**
	 * Load initial index data
	 *
	 * @param {Function} [fn]
	 */
	load(fn) {
		const scope = this;
		const pub = scope.$public;
		const conf = pub.conf;
		const model = {
			label: 'result',
			base: LS.filters.base()
		};

		if (conf.sorting) {
			model.sorting = conf.sorting;
		}

		conf.model = Object.assign({}, model, conf.model);

		if (conf.value) {
			scope.transform(conf, conf.value);
			scope.populate(conf.value, fn);

			scope.fetched = true;

			return;
		}

		pub.request({
			filters: scope.prep(conf.filters),
			resource: conf.resource,
			send: conf.send,
			transform: conf.transform
		}, data => {
			scope.populate(data, fn);
		});
	},

	/**
	 * Populate model data
	 *
	 * @param {Object} data
	 * @param {Function} [fn]
	 */
	populate(data, fn) {
		const scope = this;
		const pub = scope.$public;
		const conf = pub.conf;

		data = Object.assign({}, conf.model, data);

		if (conf.reset) {
			data.reset = LS.filters.count();
		}

		pub.app = $.app.make(conf.app, {
			model: data,
			target: conf.$target,
			view: conf.view,
			init: conf.init
		});

		if (conf.sorting) {
			scope.bindSorting();
		}

		if (conf.paginate) {
			scope.paginate();
		}

		if (fn) {
			fn(data);
		}

		scope.update(data, true);
	},

	/**
	 * Navigate index to new path
	 *
	 * @param {Object} options
	 * @param {Object} [data]
	 */
	go(options, data) {
		const fn = () => this.request(options, data);

		if (options.path.startsWith('/me')) {
			LS.user.guard(fn);

			return;
		}

		fn();
	},

	/**
	 * Process request
	 *
	 * @param {Object} options
	 * @param {Object} [data]
	 */
	request(options, data) {
		const scope = this;
		const pub = scope.$public;
		const conf = pub.conf;
		const updateClass = '-is-updating';

		pub.abort();

		conf.$target.addClass(updateClass);

		if (scope.fetched) {
			$.exec(conf.unload);
		}

		data = LS.util.sanitize(data);

		$.exec(conf.translate, {
			args: [data, options]
		});

		scope.xhr = $.history.go($.extend(true, {
			event: conf.event,
			force: true,
			run: false,
			scrollEarly: true,
			scrollTop: (a, obj) => scope.scrollTop(conf, obj),
			scrollTarget: () => scope.scrollTarget(conf),
			begin: conf => {
				if (! pub.app) {
					$.history.go(conf.path);

					return false;
				}
			},
			replace: obj => {
				pub.app.$pause();

				pub.app.$set('base', LS.filters.base());

				if (obj.results) {
					if (! scope.diff(obj)) {
						return;
					}

					scope.transform(conf, obj);

					pub.app.$merge(obj);
				}

				pub.app.$resume(true);

				return false;
			},
			request: LS.api.extend({
				auth: conf.auth,
				data: data,
				send: conf.send,
				success: obj => {
					scope.update(obj);
				},
				complete: () => {
					scope.xhr = null;

					conf.$target.removeClass(updateClass);
				}
			})
		}, options));
	},

	/**
	 * Compare new data to cache
	 *
	 * @param {Object} data
	 * @returns {boolean}
	 */
	diff(data) {
		const scope = this;

		return ! (
			data.total === scope.total &&
			$.equals(scope.active, LS.util.pluck(data.results, 'id'))
		);
	},

	/**
	 * Run update logic after data render
	 *
	 * @param {Object} data
	 * @param {Boolean} [init=false]
	 */
	update(data, init) {
		const pub = this.$public;
		const conf = pub.conf;

		if (! init && conf.sorting) {
			pub.app.$set('sort', conf.sorting[conf.filters.sort]);
		}

		if (conf.updated) {
			conf.updated(data, init);
		}
	},

	/**
	 * Run applicable result transformation
	 *
	 * @param {Object} conf
	 * @param {Object} data
	 */
	transform(conf, data) {
		if (conf.modify) {
			conf.modify(data, conf);
		}

		if (
			! conf.transform ||
			! data.results ||
			! data.results.length
		) {
			return;
		}

		data.results.forEach((result, i) => {
			conf.transform(result, i, conf);
		});
	}
});